import axios from 'axios';
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

function DetailsRequest({ request, onUpdated }) {

    const { token } = useSelector((state) => state.auth)

    const [labTime, setLabTime] = useState([])

    const updateDateForm = useForm({
        defaultValues: {
            concreteCastingDate: '',
            concreteCastingTime: ''
        }
    });

    const updateDateSubmit = (data) => {

        axios.put(`${process.env.REACT_APP_SERVICE_URL}/demands/datetime`, {
            demandId: request.id,
            date: data.concreteCastingDate,
            time: data.concreteCastingTime
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        })
            .then((response) => {
                console.log(response.data)
                swal('Başarılı', 'Tarih ve saat güncellendi.', 'success')
                if (typeof onUpdated === 'function') {
                    onUpdated(response.data)
                }
            })
            .catch((error) => {
                console.error(error)
                swal('Hata', 'Tarih ve saat güncellenirken bir hata oluştu.', 'error')
            })
    }

    const getLabTime = () => {
        const today = moment().format('YYYY-MM-DD')
        //console.log(today)
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/lab/times?localDate=${today}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setLabTime(response.data)
            })
            .catch((error) => {
                console.error(error)
                swal('Hata', 'Laboratuvar zamanları getirilirken bir hata oluştu.', 'error')

            })
    }

    useEffect(() => {
        getLabTime()
    }, [])

    useEffect(() => {
        if (!request) return
        updateDateForm.reset({
            concreteCastingDate: request?.concreteCastingDate || '',
            concreteCastingTime: request?.concreteCastingTime || ''
        })
    }, [request, updateDateForm.reset])

    return (
        <>
            <form onSubmit={updateDateForm.handleSubmit(updateDateSubmit)}>
                <div className='mb-3'>
                    <label htmlFor='concreteCastingDate' className='form-label'>Tarih</label>
                    <input type='date'
                        {...updateDateForm.register('concreteCastingDate', { required: true })}
                        className='form-control' id='concreteCastingDate' />
                </div>
                <div className='mb-3'>
                    <label htmlFor='concreteCastingTime' className='form-label'>Saat</label>
                    <select
                        {...updateDateForm.register('concreteCastingTime', { required: true })}
                        className='form-select' id='concreteCastingTime'>
                        {
                            labTime?.map((time, index) => (
                                <option key={index} disabled={!time.available} value={time.id}>{time.time}</option>
                            ))
                        }
                    </select>
                </div>
                <div className='d-flex flex-wrap gap-2'>
                    <button
                        type='submit'
                        className='btn btn-dark btn-app btn-app--lg'
                        data-tooltip-id="requests-tooltip"
                        data-tooltip-content="Talep tarih ve saatini güncelle"
                        aria-label="Talep tarih ve saatini güncelle">Güncelle</button>
                </div>
            </form>


        </>
    )
}

export default DetailsRequest